<template>
<div>
    <div class="intro-y flex items-center mt-8">
        <h2 class="text-lg font-medium mr-auto">{{ form_data.user_id == "" ? 'Create Manager' : 'Update Manager' }}</h2>
        <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
            <button v-if="form_data.user_id != '' && form_data.active_status == 1" type="button" :class="{'btn shadow-md mr-2': true,
          'btn-danger ' : form_data.active_status == 1}" @click="changeStatus">
                <LockIcon class="w-4 h-4 mr-1" /> Deactivate
            </button>
            <button v-if="form_data.user_id != '' && form_data.active_status == 0" type="button" :class="{'btn shadow-md mr-2': true,
          'btn-success ' : form_data.active_status == 0}" @click="changeStatus">
                <UnlockIcon class="w-4 h-4 mr-1" /> Activate
            </button>
            <button v-if="form_data.user_id != ''" type="button" class="btn btn-danger shadow-md mr-2" @click="deleteUser">
                <Trash2Icon class="w-4 h-4 mr-1" /> Delete Account
            </button>

        </div>
    </div>
    <div class="grid grid-cols-12 gap-6">
        <!-- BEGIN: Profile Menu -->
        <!-- <div class="col-span-3 flex lg:block flex-col-reverse">
            <div class="intro-y box mt-5 p-5">
                <div class="w-full">
                    <img alt="Profile" class="w-full" :src="form_data.user_profile ? form_data.user_profile : require(`@/assets/images/user.png`)" />
                    <input type="file" ref="upload_btn" class="hidden" @change="onFileChange">
                    <div class="flex items-center justify-end">

                        <button class="btn btn-primary mt-3 p-2 text-right" @click="onFileUploadClick">Upload</button>
                    </div>
                </div>

            </div>
        </div> -->
        <!-- END: Profile Menu -->
        <div class="col-span-12 lg:col-span-8 2xl:col-span-9">
            <!-- BEGIN: Change Password -->
            <div class="intro-y box lg:mt-5">
                <div class="flex items-center p-5 border-b border-gray-200 dark:border-dark-5">
                    <h2 class="font-medium text-base mr-auto">Manager Information</h2>
                </div>
                <div class="p-5">

                    <div class="grid grid-cols-12 gap-x-2">
                        <div class="col-span-12 sm:col-span-6">
                            <div class="mt-3">
                                <label for="first_name" class="form-label">First Name <span class="text-theme-6">*</span></label>
                                <input type="text" autocomplete="off" v-model="form_data.first_name" class="form-control" placeholder="First Name" />
                            </div>
                            <span class="text-primary-3" v-if="errors.first_name">{{ errors.first_name[0] }}</span>
                        </div>
                        <div class="col-span-12 sm:col-span-6">
                            <div class="mt-3">
                                <label for="last_name" class="form-label">Last Name <span class="text-theme-6">*</span></label>
                                <input type="text" autocomplete="off" v-model="form_data.last_name" class="form-control" placeholder="Last Name" />
                            </div>
                            <span class="text-primary-3" v-if="errors.last_name">{{ errors.last_name[0] }}</span>
                        </div>
                        <!-- <div class="col-span-12 sm:col-span-6">
                            <div class="mt-3">
                                <label for="company_name" class="form-label">Company Name <span class="text-theme-6">*</span></label>
                                <input id="company_name" type="text" autocomplete="off" v-model="form_data.company_name" class="form-control" placeholder="Company Name" />
                            </div>
                            <span class="text-primary-3" v-if="errors.company_name">{{ errors.company_name[0] }}</span>
                        </div> -->
                        <div class="col-span-12 sm:col-span-6">
                            <div class="mt-3">
                                <label for="email" class="form-label">Email (Username) <span class="text-theme-6">*</span></label>
                                <input id="email" type="email" autocomplete="off" v-model="form_data.email" :readonly="form_data.user_id != ''" class="form-control" placeholder="Email (Username)" />
                            </div>
                            <span class="text-primary-3" v-if="errors.email">{{ errors.email[0] }}</span>
                        </div>
                        <div class="col-span-12 sm:col-span-6">

                            <div class="mt-3">
                                <label for="mobile_no" class="form-label">Phone No. <span class="text-theme-6">*</span></label>
                                <input type="text" autocomplete="off" v-model="form_data.mobile_no" class="form-control" placeholder="Phone No" />
                            </div>
                            <span class="text-primary-3" v-if="errors.mobile_no">{{ errors.mobile_no[0] }}</span>
                        </div>
                        <div class="col-span-12 sm:col-span-6">
                            <div class="mt-3">
                                <label for="address" class="form-label">Manager Role</label>
                                <TomSelect v-model="form_data.user_type" :options="{
                  placeholder: 'Select User Type',
                }" class="w-full">
                                        <option value="2">Purchase Manager</option>
                                        <option value="3">Request Manager</option>
                                        <option value="4">Account Manager</option>
                                        <option value="1">Admin</option>
                                    </TomSelect>
                            </div>
                            <span class="text-primary-3" v-if="errors.user_type">{{ errors.user_type[0] }}</span>
                        </div>
                    </div>
                    <!-- <p class="text-theme-6 mt-5">In case information is incorrect kindly contact Admin for updating the information.</p> -->
                </div>
            </div>
            <div class="intro-y box lg:mt-5">
                <div class="flex items-center p-5 border-b border-gray-200 dark:border-dark-5">
                    <h2 class="font-medium text-base mr-auto">Change Password</h2>
                </div>
                <div class="p-5">

                    <div class="grid grid-cols-12 gap-x-2">
                        <div class="col-span-12 sm:col-span-6">
                            <div class="mt-3">
                                <label for="password" class="form-label">New Password <span class="text-theme-6">*</span></label>
                                <input type="password" class="form-control" minlength="6" maxlength="20" v-model="form_data.password" autocomplete="off" placeholder="New Password" />
                            </div>
                            <span class="text-primary-3" v-if="errors.password">{{ errors.password[0] }}</span>
                        </div>
                        <div class="col-span-12 sm:col-span-6">
                            <div class="mt-3">
                                <label for="confirm_password" class="form-label">Confirm New Password <span class="text-theme-6">*</span></label>
                                <input type="password" minlength="6" maxlength="20" v-model="form_data.confirm_password" autocomplete="off" class="form-control" placeholder="Confirm New Password" />
                            </div>
                            <span class="text-primary-3" v-if="errors.confirm_password">{{ errors.confirm_password[0] }}</span>
                        </div>
                    </div>

                    <div class="flex items-center justify-end">

                        <button class="btn btn-secondary mt-3 p-2 text-right mr-3" @click="this.$router.go(-1)">Cancel</button>
                        <button class="btn btn-primary mt-3 p-2 text-right" :disabled="form_data.loading == true" @click="submitForm">{{ form_data.user_id == "" ? 'Create Manager' : 'Update Manager' }}
                          <LoadingIcon v-if="form_data.loading == true" icon="oval" color="white" class="w-4 h-4 ml-2" />
                        </button>
                    </div>
                </div>
            </div>
            <!-- END: Change Password -->

            <div id="success-notification-content" class="toastify-content hidden flex">
                <CheckCircleIcon class="text-theme-9" />
                <div class="ml-4 mr-4">
                    <div class="font-medium">Password Updated Successfully!</div>
                </div>
            </div>

            <div id="failed-notification-content" class="toastify-content hidden flex">
                <InfoIcon class="text-theme-6" />
                <div class="ml-4 mr-4">
                    <div class="font-medium">Validation Error!</div>
                    <div class="text-gray-600 mt-1">
                        Please Check Password & Confirm Password (min 6 char required) and try again
                    </div>
                </div>
            </div>

            <div id="failed-server-content" class="toastify-content hidden flex">
                <InfoIcon class="text-theme-6" />
                <div class="ml-4 mr-4">
                    <div class="font-medium">Server Error!</div>
                    <div class="text-gray-600 mt-1">
                        Something went wrong! Please Try again
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
</template>

<script>
/* eslint-disable */
import {
    mapGetters
} from 'vuex'
import {
    BASE_URL
} from '@/constant/config.js'
import axios from 'axios'
import Toastify from 'toastify-js'
import {
    inject,
    onMounted,
    reactive,
    ref
} from 'vue'
import router from '@/router'
import {
    useRoute
} from 'vue-router'

export default {
    setup() {
        const user_profile = ref('')
        const upload_btn = ref('')
        const route = useRoute()
        const swal = inject('$swal')
        const errors = ref([])
        const manager_roles = ref([])
        const form_data = reactive({
            first_name: "",
            // company_name: "",
            last_name: "",
            mobile_no: "",
            email: "",
            user_profile: "",
            user_type: "2",
            password: "",
            confirm_password: "",
            active_status: "",
            user_id: route.params.user_id ? route.params.user_id : "",
            loading: false
            // new_img: ""
        })
        const onFileUploadClick = () => {
            upload_btn.value.click()
        }

        const onFileChange = (event) => {
            user_profile.value = event.target.files[0];

            form_data.user_profile = URL.createObjectURL(user_profile.value);
        }

        const submitForm = async () => {
            let formData = new FormData();

            formData.append("first_name", form_data.first_name);
            formData.append("last_name", form_data.last_name);
            formData.append("mobile_no", form_data.mobile_no);
            formData.append("email", form_data.email);
            formData.append("user_profile", user_profile.value);
            // formData.append("company_name", form_data.company_name);
            formData.append("user_type", form_data.user_type);
            formData.append("password", form_data.password);
            formData.append("confirm_password", form_data.confirm_password);
            formData.append("id", form_data.user_id);

            let config = {
                'content-type': 'multipart/form-data',
                'Accept': "application/json"
            }

            let uri = ""

            if (form_data.user_id != "") {
                uri = "api/master/update_manager"
            } else {
                uri = "api/master/create_manager"

            }
            form_data.loading = true
            let promise = axios({
                url: uri,
                method: "post",
                baseURL: BASE_URL,
                data: formData,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token")
                },
                config: config
            });
            return promise
                .then(result => result.data)
                .then(data => {

                    if (data.error == "NO") {

                        swal("Success !", data.message, "success")

                        router.push({
                            path: "/master/manager/list"
                        })
                        return
                    }
                    form_data.loading = false
                    swal("Error !", data.message, "error")
                    return
                })
                .catch(_error => {
                  form_data.loading = false
                    errors.value = _error.response.data.errors
                    swal("Error !", "Something went wrong.", "error")
                    return
                });
        }
        const get_user_details = async () => {

            let params = {
                id: route.params.user_id,
            }

            let config = {
                'Accept': "application/json"
            }

            let promise = axios({
                url: "api/master/edit_manager",
                method: "post",
                baseURL: BASE_URL,
                data: params,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token")
                },
                config: config
            });
            return promise
                .then(result => result.data)
                .then(data => {

                    form_data.first_name = data.item.first_name ? data.item.first_name : ""
                    form_data.last_name = data.item.last_name ? data.item.last_name : ""
                    form_data.mobile_no = data.item.mobile_no ? data.item.mobile_no : ""
                    form_data.email = data.item.email ? data.item.email : ""
                    form_data.user_profile = data.item.user_profile ? data.item.user_profile : ""
                    form_data.user_type = String(data.item.user_type)
                    form_data.password = data.item.password ? data.item.password : ""
                    // form_data.company_name = data.item.company_name
                    form_data.confirm_password = data.item.password ? data.item.password : ""
                    form_data.active_status = data.item.active_status ? data.item.active_status : ""
                    // form_data.user_id = data.item.user_id

                })
                .catch(_error => {
                    form_data.first_name = ""
                    form_data.last_name = ""
                    form_data.mobile_no = ""
                    form_data.email = ""
                    form_data.user_profile = ""
                    form_data.user_type = "2"
                    form_data.password = ""
                    // form_data.company_name = ""
                    form_data.confirm_password = ""
                    form_data.active_status = ""
                    // form_data.user_id = ""
                });
        }

        const changeStatus = () => {

            swal({
                title: "Are you sure?",
                text: "You are about to ChangeStatus Manager!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Confirm",
                showLoaderOnConfirm: true,
                cancelButtonText: "Cancel",

                allowOutsideClick: () => !$Swal.isLoading()
            }).then(result => {
                if (result.isConfirmed) {

                    let config = {
                        'Accept': "application/json"
                    }

                    let uri = ""

                    if (form_data.user_id != "") {
                        uri = "api/master/inactive_manager"
                    } else {
                        uri = "api/master/inactive_manager"

                    }

                    let promise = axios({
                        url: uri,
                        method: "post",
                        baseURL: BASE_URL,
                        data: {
                            id: form_data.user_id
                        },
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("token")
                        },
                        config: config
                    });
                    return promise
                        .then(result => result.data)
                        .then(data => {

                            if (data.error == "NO") {

                                swal("Success !", data.message, "success")

                                get_user_details()
                                return
                            }

                            swal("Error !", data.message, "error")
                            return
                        })
                        .catch(_error => {
                            errors.value = _error.response.data.errors
                            swal("Error !", "Something went wrong.", "error")
                            return
                        });

                }
            });

        }
        const deleteUser = () => {

            swal({
                title: "Are you sure?",
                text: "You are about to Delete Manager!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Confirm",
                showLoaderOnConfirm: true,
                cancelButtonText: "Cancel",

                allowOutsideClick: () => !$Swal.isLoading()
            }).then(result => {
                if (result.isConfirmed) {

                    let config = {
                        'Accept': "application/json"
                    }

                    let uri = ""

                    if (form_data.user_id != "") {
                        uri = "api/master/delete_manager"
                    } else {
                        uri = "api/master/delete_manager"

                    }

                    let promise = axios({
                        url: uri,
                        method: "post",
                        baseURL: BASE_URL,
                        data: {
                            id: form_data.user_id
                        },
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("token")
                        },
                        config: config
                    });
                    return promise
                        .then(result => result.data)
                        .then(data => {

                            if (data.error == "NO") {

                                swal("Success !", data.message, "success")

                                router.push({
                                    path: "/master/manager/list"
                                })
                                return
                            }

                            swal("Error !", data.message, "error")
                            return
                        })
                        .catch(_error => {
                            errors.value = _error.response.data.errors
                            swal("Error !", "Something went wrong.", "error")
                            return
                        });

                }
            });

        }

        onMounted(() => {
            if (route.params.user_id) {
                get_user_details()
            }
        })

        return {
            form_data,
            upload_btn,
            user_profile,
            onFileChange,
            submitForm,
            onFileUploadClick,
            errors,
            changeStatus,
            deleteUser,
            manager_roles
        }
    },
}
</script>
